

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'
import router from './router'
import {
getOpenId,
} from "./utils";
import {
getJssdkSingature,
} from "@/apis";
import WechatPlugin from 'vux/src/plugins/wechat/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'

import {
shareConfig,
} from "@/config";
Vue.use(VueRouter)
Vue.use(WechatPlugin)
Vue.use(ToastPlugin)


router.beforeEach((to, from, next) => {
if (to.meta.title) {
document.title = to.meta.title;
}
const openId = getOpenId();
if (openId) {
next();
} else {
const url = encodeURIComponent(location.href);
window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9dae4a3e9c1bb204&redirect_uri=${location.origin}/grant&response_type=code&scope=snsapi_userinfo&state=${url}#wechat_redirect`;
}
})
getJssdkSingature({

data: location.toString()
}).then(res => {
const data = Object.assign({}, res.data, {

jsApiList: [
'chooseWXPay',
'updateAppMessageShareData',
'updateTimelineShareData',
'onMenuShareTimeline',
'onMenuShareAppMessage'
]
});
Vue.wechat.config(data);
Vue.wechat.ready(() => {
Vue.wechat.updateAppMessageShareData && Vue.wechat.updateAppMessageShareData(shareConfig);
Vue.wechat.updateTimelineShareData && Vue.wechat.updateTimelineShareData(shareConfig);
Vue.wechat.onMenuShareTimeline && Vue.wechat.onMenuShareTimeline(shareConfig);
Vue.wechat.onMenuShareAppMessage && Vue.wechat.onMenuShareAppMessage(shareConfig);
});
})
FastClick.attach(document.body)

/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js